import { Fragment } from "react";
import { DashedCard } from "../ui/DashedCard";
import { PRIVACY_FLOW } from "../data/privacy";

function Arrow() {
  return (
    <div className="self-center relative h-6 w-px border-l border-dashed border-accent">
      <div className="absolute -bottom-0.5 -left-[3px] size-0 border-x-4 border-x-transparent border-t-[5px] border-t-accent" />
    </div>
  );
}

export function PrivacyFlow() {
  return (
    <div className="flex flex-col">
      {PRIVACY_FLOW.map((node, i) => (
        <Fragment key={node.title}>
          <DashedCard accent hover={false} className="p-5 border-accent">
            <div className="font-mono text-xs tracking-wider uppercase text-accent">
              {node.title}
            </div>
            <div className="mt-2 text-sm text-td-2">{node.body}</div>
          </DashedCard>
          {i < PRIVACY_FLOW.length - 1 && <Arrow />}
        </Fragment>
      ))}
      <p className="mt-4 text-sm italic text-td-3">
        Our central DB holds contacts, encrypted tokens, and your automation
        definitions. Messages live on your VM volume. Models see only what each
        request needs.
      </p>
    </div>
  );
}
